import React from "react";
import { Badge, colors } from "../design/badge";
import { TeamMemberRole } from "../models/TeamMember";

interface TeamMemberRoleBadgeProps {
  role: TeamMemberRole;
}

const TeamMemberRoleBadge: React.FC<TeamMemberRoleBadgeProps> = ({ role }) => {
  let color;
  let title;

  switch (role) {
    case "owner":
      color = "red"; // Indicates danger or important
      title = "Owner";
      break;
    case "admin":
      color = "green"; // Indicates success or completion
      title = "Admin";
      break;
    case "editor":
      color = "blue"; // Indicates information
      title = "Editor";
      break;
    default:
      color = "zinc"; // Default color if status is unknown
      title = role ?? "Unknown";
      break;
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default TeamMemberRoleBadge;
